import React, { useEffect, useRef, useState } from 'react';
import { IonContent, IonItem, IonModal, IonPage } from '@ionic/react';
import { useHistory } from 'react-router-dom';
import { ApiService } from '../api/ApiService';
import { toastStore } from '../components/AppToast';
import arrowImg from '../imgs/arrow.png';
import trailer from '../imgs/trailer.png';
import navigation from '../imgs/navigation.png';
import { StopDetails as StoredStopInfo } from '../api/model/StopDetails';
import { LoadInfo as StoredLoadInfo } from '../api/model/LoadInfo';
import { DriverProfile } from '../api/model/DriverProfile';
import { UserState, userStore } from '../api/AuthService';
import { Map, AdvancedMarker, useAdvancedMarkerRef, useMap } from '@vis.gl/react-google-maps';
import { PluginListenerHandle } from '@capacitor/core';
import TrailerMarker from '../components/TrailerMarker';
import { decode } from '@googlemaps/polyline-codec';
import LoadDetailHeader, { useTransparentHeaderContrast } from '../components/LoadDetailHeader';
import { TrailerIcon } from '../components/icons';
import AvailableTrailerFirstIn from '../components/walkthrough/individualPage/AvailableTrailerFirstIn';
import { useLogPageVisit } from '../utils/logPageVisit';
import { logUserAction } from '../utils/logUserAction';

type trailer = {
  distance: number;
  lastPing: string;
  latitude: number;
  longitude: number;
  asset_id: string;
};

let routePolyline = new google.maps.Polyline({
  path: [],
  geodesic: true,
  strokeColor: '#99ff13',
  strokeOpacity: 1.0,
  strokeWeight: 8,
});

let timer: any = null;

let lati: any = 0;
let long: any = 0;

const TrailerTracking: React.FC = () => {
  useLogPageVisit('LP Trailer Check', 'User has viewed the Trailer Tracking page');
  const trailerMap: any = useMap('trailerMap');
  const history = useHistory();
  const { onSheet, onIonScroll } = useTransparentHeaderContrast();
  const [mounted, setMounted] = useState(false);

  const { userInfo }: { userInfo: DriverProfile } = userStore((state: UserState) => ({
    userInfo: state.driver,
  }));
  const { storedStopInfo }: { storedStopInfo: StoredStopInfo } = userStore((state: UserState) => ({
    storedStopInfo: state.stopDetails,
  }));
  const { storedLoadInfo }: { storedLoadInfo: StoredLoadInfo } = userStore((state: UserState) => ({
    storedLoadInfo: state.loadInfo,
  }));

  let watchId: any;
  let distanceArray: number[] = [];
  let accelHandler: PluginListenerHandle;
  let compassHold = 0;
  const [trailers, setTrailers] = useState<trailer[]>([]);
  const [routedTrailer, setRoutedTrailer] = useState<any>([]);
  const [centerLat, setCenterLat] = useState<number>(0);
  const [centerLong, setCenterLong] = useState<number>(0);
  const [distance, setDistance] = useState<number>(0);
  const [dispatchedCustomerCode, setDispatchedCustomerCode] = useState<string>('');
  const [selectTerminal, setSelectTerminal] = useState(true);
  const [heading, setHeading] = useState<any>(0);
  const [markerRef, marker] = useAdvancedMarkerRef();
  const [hasPermission, setHasPermission] = useState<boolean>(false);
  const routingView = useRef<boolean>(false);

  useEffect(() => {
    const id = requestAnimationFrame(() => {
      setTimeout(() => setMounted(true), 30);
    });
    return () => cancelAnimationFrame(id);
  }, []);

  const goBack = () => {
    if (history.length > 1) history.goBack();
    else history.replace('/Trip');
  };

  function successWatch(position: any) {
    setHeading(position.coords.heading === null ? heading : position.coords.heading);
    lati = position.coords.latitude;
    long = position.coords.longitude;
  }

  function errorWatch(err: any) {
    console.error(`ERROR(${err.code}): ${err.message}`);
  }

  let options = {
    enableHighAccuracy: true,
    timeout: 2000,
    maximumAge: 0,
  };

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(successWatch, errorWatch);
    if (trailerMap) {
      console.log('stop Info', trailerMap);
    }
    return () => {
      clearInterval(timer);
      window.removeEventListener(
        'deviceorientation',
        e => {
          handler(e);
        },
        true
      );
      window.removeEventListener('deviceorientationabsolute', handler, true);
    };
  }, [trailerMap]);

  function permission() {
    console.log(
      'permisson here',
      typeof (DeviceMotionEvent as any).requestPermission() !== 'undefined'
    );
    (DeviceOrientationEvent as any)
      .requestPermission()
      .then((response: any) => {
        if (response == 'granted') {
          console.log('permission');
          window.addEventListener(
            'deviceorientation',
            e => {
              handler(e);
            },
            true
          );
        }
      })
      .catch(console.error);
  }

  window.addEventListener('touchmove', e => {
    routingView.current = false;
    handler(e);
  });

  function handler(e: any) {
    let compass = e.webkitCompassHeading || Math.abs(e.alpha - 360);
    if (Number.isNaN(compass)) compass = compassHold;
    let userMaker = document.getElementById('userMaker');
    if (userMaker !== null) {
      if (trailerMap) {
        let mapHeading = trailerMap.getHeading();
        mapHeading = 360 - mapHeading;
        userMaker.style.transform = `rotate(${parseInt(compass) + mapHeading}deg)`;
      }
    }
    compassHold = compass;
  }

  function checkForDMLocation() {
    if (typeof (DeviceMotionEvent as any).requestPermission === 'function') {
      permission();
    } else {
      window.addEventListener('deviceorientationabsolute', handler, true);
    }
    let orderNumber: any = storedLoadInfo.orderNumber;
    let unitNumber: any = userInfo.unit;
    ApiService.trailerLocationGet('trailer tracking', { unitNumber, orderNumber }, true)
      .then(it => {
        findTrailers(it);
      })
      .catch(error => {
        console.error('here it is', error);
        getCurrentDispatch();
      });
  }

  function getCurrentDispatch() {
    navigator.geolocation.getCurrentPosition(successWatch, errorWatch);
    let stopsArray: any = storedStopInfo;
    stopsArray.forEach((element: any) => {
      if (element.sequenceNumber === parseInt(storedLoadInfo.dispatchNumber)) {
        setDispatchedCustomerCode(element.customerCode);
        const idObj: any = {
          polyId: element.customerCode,
        };
        findTrailers(idObj);
      }
    });
  }

  function userCenter(trailerVar?: any) {
    if (routedTrailer.length !== 0 || trailerVar !== undefined)
      routingView.current = !routingView.current;
    console.log('routingView', routingView.current, routedTrailer);
    let center = new google.maps.LatLng({ lat: lati, lng: long });
    trailerMap.panTo(center);
    trailerMap.setCenter(center);
    trailerMap.setZoom(18);
  }

  function setPolygonCenter() {
    let center = new google.maps.LatLng({ lat: centerLat, lng: centerLong });
    trailerMap.panTo(center);
    trailerMap.setZoom(16);
  }

  function findTrailers(idObj: any) {
    watchId = navigator.geolocation.watchPosition(successWatch, errorWatch, options);
    ApiService.trailerCustomerPoly('trailer tracking', { customerCode: idObj.polyId }).then(it => {
      processTrailers(it);
    });
  }

  async function processTrailers(trailerList: any) {
    let tempArray: any = [];
    trailerList.trailers.forEach((element: any) => {
      let tempObj = { trailerId: '', lastPing: '', latitude: 0, longitude: 0, status: '' };
      tempObj = element;
      tempArray.push(tempObj);
    });
    setTrailers(tempArray);
    if (tempArray.length === 0) {
      toastStore.getState().setToast('No available trailers found at this terminal.');
      return;
    }
    setCenterLat(tempArray[0].centroid[0]);
    setCenterLong(tempArray[0].centroid[1]);
    let center = new google.maps.LatLng({
      lat: tempArray[0].centroid[0],
      lng: tempArray[0].centroid[1],
    });
    trailerMap.setCenter(center);
  }

  function getRoute(trailer?: any) {
    if (lati !== 0 && long !== 0) {
      console.log('route call', lati, long);
      let tempCoords: any = {
        startLati: lati.toString(),
        startLong: long.toString(),
        destLati: trailer.latitude || routedTrailer.latitude,
        destLong: trailer.longitude || routedTrailer.longitude,
        travelMode: 'DRIVE',
      };
      ApiService.routeCompute('Trailer Check', tempCoords).then(it => {
        decodePath(it);
      });
    }
  }

  function decodePath(polylinePath: any) {
    setDistance(polylinePath.distanceMeters);
    let setTempPolyline: any = polylinePath.polyline.encodedPolyline;
    let tempPath: any = decode(setTempPolyline, 5);
    let llArray: google.maps.LatLng[] = [];
    update(tempPath);
    tempPath.forEach((element: any) => {
      let tempObj = new google.maps.LatLng(element[0], element[1]);
      llArray.push(tempObj);
    });
    routePolyline.setPath(llArray);
    routePolyline.setMap(trailerMap);
    trailerMap.setTilt(55);
  }

  function update(path: any) {
    const mark1: any = { lat: path[0][0], lng: path[0][1] };
    const mark2: any = { lat: path[1][0], lng: path[1][1] };
    let heading = google.maps.geometry.spherical.computeHeading(mark1, mark2);
    if (heading < 0) heading = Math.round(360 + heading);
    if (routingView.current === true) {
      trailerMap.setHeading(heading);
      let center = new google.maps.LatLng({ lat: lati, lng: long });
      trailerMap.setCenter(center);
    }
  }

  function trailerPoint(trailerInfo: any) {
    logUserAction('LP Select Trailer', 'User selected an available trailer');
    console.log('trailerInfo', trailerInfo);
    setRoutedTrailer(trailerInfo);
    clearInterval(timer);
    timer = setInterval(
      () => {
        if (trailerInfo.length !== 0) {
          getRoute(trailerInfo);
          console.log('lati long', lati, long);
        }
      },
      2000,
      lati,
      long
    );
    userCenter(trailerInfo);
  }

  const exitRoute = () => {
    navigator.geolocation.clearWatch(watchId);
    setRoutedTrailer([]);
    trailerMap.setZoom(17);
    trailerMap.setHeading(0);
    let center = new google.maps.LatLng({ lat: centerLat, lng: centerLong });
    trailerMap.setCenter(center);
    routingView.current = false;
    trailerMap.setTilt(0);
    clearInterval(timer);
    routePolyline.setPath([]);
    routePolyline.setMap(null);
  };

  return (
    <AvailableTrailerFirstIn>
      <IonPage>
        <LoadDetailHeader title="Available Trailers" onBack={goBack} onSheet={onSheet} />
        <IonContent
          fullscreen
          className="design-a-content design-a-content--light"
          scrollEvents={true}
          onIonScroll={onIonScroll}
        >
          <IonModal isOpen={selectTerminal} cssClass="my-custom-class">
            <div
              className={`design-a design-a--detail${mounted ? ' design-a--mounted' : ''}`}
              style={{ minHeight: '100%' }}
            >
              <div className="home-hero preplan-hero">
                <div className="safety-hero__badge" aria-hidden="true">
                  <TrailerIcon color="#ffffff" size={26} />
                </div>
                <div className="preplan-hero__eyebrow">Load</div>
                <div className="preplan-hero__title home-display">Available Trailers</div>
                <div className="preplan-hero__meta">Read before selecting a trailer</div>
              </div>
              <div className="home-sheet preplan-sheet" style={{ paddingBottom: 32 }}>
                <div className="advance-card">
                  <div className="advance-card__title">Please read</div>
                  <p className="advance-card__body">
                    UPON SELECTING A TRAILER, ALWAYS BE SURE TO CONFIRM IT IS ACTUALLY EMPTY. IF
                    TRAILER IS SEALED, DO NOT TAKE TRAILER OR TAMPER WITH OR REMOVE SEAL.
                  </p>
                  <button
                    type="button"
                    className="profile-submit"
                    onClick={() => {
                      checkForDMLocation();
                      setSelectTerminal(false);
                    }}
                  >
                    Acknowledge
                  </button>
                </div>
              </div>
            </div>
          </IonModal>

          <div
            style={{
              position: 'relative',
              height: '100%',
              top: 0,
              zIndex: 2,
              width: '100%',
              overflow: 'hidden',
              scrollbarWidth: 'none',
            }}
          >
            <Map
              style={{ width: '100vw', height: '100vh' }}
              defaultCenter={{ lat: lati, lng: long }}
              defaultZoom={15}
              defaultTilt={16}
              mapTypeControl={true}
              gestureHandling={'greedy'}
              id={'trailerMap'}
              mapId={'4075003bf6f2d132'}
              disableDefaultUI={true}
            >
              <AdvancedMarker position={{ lat: lati, lng: long }} ref={markerRef}>
                <div style={{ position: 'relative' }}>
                  <div className="userIcon"></div>
                  <div className="box" id="userMaker"></div>
                </div>
              </AdvancedMarker>
              {routedTrailer.length !== 0 ? (
                <TrailerMarker element={routedTrailer} />
              ) : (
                trailers.map(element => <TrailerMarker element={element} onSelect={trailerPoint} />)
              )}
            </Map>
          </div>
          {!selectTerminal && (
            <div
              style={{
                zIndex: 3,
                width: '100%',
                position: 'relative',
                pointerEvents: 'none',
                display: 'flex',
                justifyContent: 'end',
              }}
            >
              <div style={{ bottom: '10px', position: 'absolute', display: 'flex' }}>
                {routedTrailer.length !== 0 ? (
                  <div style={{ margin: 'auto' }}>
                    <IonItem
                      lines="none"
                      style={{
                        '--background': '#272727',
                        borderRadius: '6px',
                        pointerEvents: 'auto',
                      }}
                    >
                      <div style={{ display: 'flex' }}>
                        <span
                          style={{
                            color: '#b3b3b3',
                            fontSize: '15px',
                            margin: '30px 5px 30px 10px',
                          }}
                        >
                          <b>Trailer:</b> {routedTrailer.trailerId}
                        </span>
                        <span
                          style={{
                            color: '#b3b3b3',
                            fontSize: '15px',
                            margin: '30px 15px 30px 10px',
                          }}
                        >
                          <b>Distance:</b> {distance} m
                        </span>
                        <div style={{ margin: 'auto 5px' }}>
                          <button className="western-button-cancel" onClick={exitRoute}>
                            Exit
                          </button>
                        </div>
                      </div>
                    </IonItem>
                  </div>
                ) : null}
                <div>
                  <IonItem lines="none" color="none">
                    <button
                      style={{
                        background: 'white',
                        borderRadius: '30px',
                        width: '60px',
                        height: '60px',
                        boxShadow: '0px 0px 4px black',
                        margin: '10px 2px',
                        pointerEvents: 'auto',
                      }}
                      onClick={() => {
                        userCenter();
                      }}
                    >
                      {routingView.current === true ? (
                        <img src={navigation} width={'30px'} alt="" />
                      ) : (
                        <img src={arrowImg} width={'30px'} alt="" />
                      )}
                    </button>
                  </IonItem>
                  <IonItem lines="none" color="none">
                    <button
                      style={{
                        background: '#99ff13',
                        borderRadius: '30px',
                        width: '60px',
                        height: '60px',
                        boxShadow: '0px 0px 4px black',
                        margin: '10px 2px',
                        pointerEvents: 'auto',
                      }}
                      onClick={() => {
                        routingView.current = false;
                        setPolygonCenter();
                      }}
                    >
                      <img src={trailer} width={'30px'} alt="" />
                    </button>
                  </IonItem>
                </div>
              </div>
            </div>
          )}
        </IonContent>
      </IonPage>
    </AvailableTrailerFirstIn>
  );
};

export default TrailerTracking;
